import { useFormContext } from 'react-hook-form';
import { AsyncSearchHubspotDealField, MultipleAsyncSearchHubspotDealFieldProps } from '@anytag/shared-molecules';
import { useSetHubspotDealIntoUrl } from '../hooks';
import { MarketplaceFormKeys, MarketplaceFormValues } from '../types';

export const HubspotDealField = (
  props: Omit<MultipleAsyncSearchHubspotDealFieldProps<MarketplaceFormKeys>, 'name' | 'multiple'>
) => {
  const { setValue } = useFormContext<MarketplaceFormValues>();
  const { setHubspotDealIntoUrl } = useSetHubspotDealIntoUrl();

  const handleHubspotDealsChange: MultipleAsyncSearchHubspotDealFieldProps<MarketplaceFormKeys>['onChange'] = (
    _,
    value
  ) => {
    setValue(MarketplaceFormKeys.hubspotDealIds, value);
    setHubspotDealIntoUrl(value);
    // TODO: We already changed the gql from HubspotDealsList to HubspotDealsListMcp which is still missing some fields so the logics here not working anymore
    // TODO: Recheck when BE has update about HubspotDealsListMcp
    // const hubspotDeal = hubspotDeals.length === 1 ? hubspotDeals[0] : undefined;

    // if (isAddMode && hubspotDeal) {
    //   // this may not work cause ownerName from bigQuery may not match our PICs name
    //   const salesPicId = hubspotDeal?.ownerName
    //     ? allPicsUserOptions.find((el) => el.label === hubspotDeal?.ownerName)?.value
    //     : null;
    //   setValue(MarketplaceFormKeys.salesPicIds, salesPicId ? [salesPicId] : [], { shouldValidate: true });
    //   setValue(MarketplaceFormKeys.countryId, hubspotDeal?.country || '', { shouldValidate: true });
    //   const isCampaignPeriodValid =
    //     hubspotDeal?.startDate &&
    //     (isAfter(new Date(hubspotDeal?.startDate), new Date()) ||
    //       isSameDay(new Date(hubspotDeal?.startDate), new Date()));
    //   if (isCampaignPeriodValid) {
    //     // if campaign has correct start date it should have correct endDate too
    //     setValue(
    //       MarketplaceFormKeys.period,
    //       { startDate: hubspotDeal?.startDate || '', endDate: hubspotDeal?.endDate || '' },
    //       { shouldValidate: true }
    //     );
    //   }
    //   setValue(MarketplaceFormKeys.title, hubspotDeal?.dealName || '', { shouldValidate: true });
    // }
  };

  return (
    <AsyncSearchHubspotDealField
      onChange={handleHubspotDealsChange}
      name={MarketplaceFormKeys.hubspotDealIds}
      multiple
      {...props}
    />
  );
};
